import { ATTRIBUTES, TAGS } from "./constants";

export class ExchangeRequests {
  public static getItemRequest(id: string): string {
    const request: string =
      // tslint:disable: quotemark
      '<?xml version="1.0" encoding="utf-8"?>' +
      '<soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"' +
      '               xmlns:xsd="http://www.w3.org/2001/XMLSchema"' +
      '               xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">' +
      "  <soap:Header>" +
      '    <RequestServerVersion Version="Exchange2013" xmlns="http://schemas.microsoft.com/exchange/services/2006/types" soap:mustUnderstand="0" />' +
      "  </soap:Header>" +
      "  <soap:Body>" +
      '    <GetItem xmlns="http://schemas.microsoft.com/exchange/services/2006/messages"' +
      '             xmlns:t="http://schemas.microsoft.com/exchange/services/2006/types">' +
      "      <ItemShape>" +
      "        <t:BaseShape>IdOnly</t:BaseShape>" +
      "        <t:AdditionalProperties>" +
      '            <t:FieldURI FieldURI="item:InternetMessageHeaders"/>' +
      "        </t:AdditionalProperties>" +
      "      </ItemShape>" +
      `      <ItemIds><t:ItemId Id="${id}"/></ItemIds>` +
      "    </GetItem>" +
      "  </soap:Body>" +
      "</soap:Envelope>";
    // tslint: enable
    return request;
  }

  public static getFoldersRequest(): string {
    const request: string =
      // tslint:disable: quotemark
      '<?xml version="1.0" encoding="utf-8"?>' +
      '   <soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/"' +
      '                  xmlns:t="http://schemas.microsoft.com/exchange/services/2006/types">' +
      "       <soap:Body>" +
      '           <FindFolder Traversal="Deep" xmlns="http://schemas.microsoft.com/exchange/services/2006/messages">' +
      "               <FolderShape>" +
      "                   <t:BaseShape>Default</t:BaseShape>" +
      "                   <t:AdditionalProperties>" +
      '                       <t:FieldURI FieldURI="folder:FolderClass" />' +
      "                   </t:AdditionalProperties>" +
      "               </FolderShape>" +
      "               <ParentFolderIds>" +
      '                   <t:DistinguishedFolderId Id="msgfolderroot"/>' +
      "               </ParentFolderIds>" +
      "               <Restriction>" +
      '                   <And xmlns="http://schemas.microsoft.com/exchange/services/2006/types">' +
      "                       <t:IsGreaterThan>" +
      '                           <t:FieldURI FieldURI="folder:TotalCount" />' +
      "                           <t:FieldURIOrConstant>" +
      '                               <t:Constant Value="0" />' +
      "                           </t:FieldURIOrConstant>" +
      "                       </t:IsGreaterThan>" +
      "                       <t:IsEqualTo>" +
      '                           <t:FieldURI FieldURI="folder:FolderClass" />' +
      "                           <t:FieldURIOrConstant>" +
      '                               <t:Constant Value="IPF.Note" />' +
      "                           </t:FieldURIOrConstant>" +
      "                       </t:IsEqualTo>" +
      '                       <Not xmlns="http://schemas.microsoft.com/exchange/services/2006/types">' +
      '                           <t:Contains ContainmentMode="FullString" ContainmentComparison="IgnoreCase">' +
      '                               <t:FieldURI FieldURI="folder:DisplayName" />' +
      '                                   <t:Constant Value="Junk Email" />' +
      "                           </t:Contains>" +
      "                       </Not>" +
      "                   </And>" +
      "               </Restriction>" +
      "           </FindFolder>" +
      "       </soap:Body>" +
      "   </soap:Envelope>";
    // tslint: enable

    return request;
  }

  public static findItemsRequest(query: string, folderId: string): string {
    const request: string =
      // tslint:disable: quotemark
      '<?xml version="1.0" encoding="utf-8"?>' +
      '<soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/"' +
      '               xmlns:t="http://schemas.microsoft.com/exchange/services/2006/types">' +
      "   <soap:Body>" +
      '       <FindItem xmlns="http://schemas.microsoft.com/exchange/services/2006/messages"' +
      '                 xmlns:t="http://schemas.microsoft.com/exchange/services/2006/types"' +
      '                 Traversal="Shallow">' +
      "           <ItemShape>" +
      "               <t:BaseShape>IdOnly</t:BaseShape>" +
      "           </ItemShape>" +
      "           <ParentFolderIds>" +
      `               <t:FolderId Id="${folderId}"/>` +
      "           </ParentFolderIds>" +
      "           <QueryString>" +
      query +
      "</QueryString>" +
      "       </FindItem>" +
      "   </soap:Body>" +
      "</soap:Envelope>";
    // tslint: enable
    return request;
  }

  public static markAsJunkRequest(id: string): string {
    const request: string =
      // tslint:disable: quotemark
      '<?xml version="1.0" encoding="utf-8"?>' +
      '<soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/"' +
      '               xmlns:t="http://schemas.microsoft.com/exchange/services/2006/types">' +
      "   <soap:Header>" +
      '       <t:RequestServerVersion Version="Exchange2013" />' +
      "   </soap:Header>" +
      "   <soap:Body>" +
      '       <MarkAsJunk xmlns="http://schemas.microsoft.com/exchange/services/2006/messages"' +
      '                   xmlns:t="http://schemas.microsoft.com/exchange/services/2006/types"' +
      '                   IsJunk="true" MoveItem="true">' +
      "           <ItemIds>" +
      `               <t:ItemId Id="${id}" />` +
      "           </ItemIds>" +
      "       </MarkAsJunk>" +
      "   </soap:Body>" +
      "</soap:Envelope>";
    // tslint: enable
    return request;
  }

  public static getInboxRulesRequest(email: string): string {
    const request: string =
      // tslint:disable: quotemark
      '<?xml version="1.0" encoding="utf-8"?>' +
      '<soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"' +
      '               xmlns:m="http://schemas.microsoft.com/exchange/services/2006/messages"' +
      '               xmlns:t="http://schemas.microsoft.com/exchange/services/2006/types"' +
      '               xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">' +
      "   <soap:Header>" +
      '       <t:RequestServerVersion Version="Exchange2010_SP1" />' +
      "   </soap:Header>" +
      "   <soap:Body>" +
      "       <m:GetInboxRules>" +
      `           <m:MailboxSmtpAddress>${email}</m:MailboxSmtpAddress>` +
      "       </m:GetInboxRules>" +
      "   </soap:Body>" +
      "</soap:Envelope>";
    // tslint: enable
    return request;
  }

  public static parseFolderIds(xmlDoc: Document, excludeFolders: string[] = ["Deleted Items"]): string[] {
    let folderIds: string[] = [];

    let folders: HTMLCollection = xmlDoc.getElementsByTagName(TAGS.FOLDER);

    if (!folders || folders.length === 0) {
      folders = xmlDoc.getElementsByTagName(TAGS.T_FOLDER);
    }

    if (folders && folders.length > 0) {
      for (let i: number = 0; i < folders.length; i++) {
        const folder: Element = folders.item(i)!;

        let nameElement: Element = this.getElementByTagName(folder, "DisplayName");
        if (nameElement) {
          if (excludeFolders.filter((f) => f === nameElement.textContent).length > 0) {
            continue;
          }
        }

        let idElement: Element = this.getElementByTagName(folder, TAGS.FOLDER_ID);
        if (idElement) {
          folderIds.push(idElement.getAttribute(ATTRIBUTES.ID)!);
        }
      }
    }

    return folderIds;
  }

  private static getElementByTagName(element: Element, tag: string): Element {
    let tagElement: Element = element.getElementsByTagName(TAGS.TAG)[0];

    if (!tagElement) {
      tagElement = element.getElementsByTagName(`t:${tag}`)[0];
    }

    return tagElement;
  }
}
